import { isServer } from './utils';

// The mobile app opens hub pages in its in-app browser with
// ?source=app&appScheme=<its URL scheme> (waybetter-mobile's
// use-navigate-to-supercharger-game.js). Kept in sessionStorage, since the
// query string is gone a page or two later (e.g. by the GLP Won success
// step), while sessionStorage lasts as long as that in-app browser.
const STORAGE_KEY = 'wb.openedFromApp';

// Only a WayBetter app's own scheme (e.g. waybetterstageapp) - never an
// http(s) URL or someone else's app, so this can't redirect anywhere else.
const APP_SCHEME = /^waybetter[a-z]*$/;

const read = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
  } catch {
    return null;
  }
};

/**
 * Remembers that this visit came from the mobile app, when the page's URL
 * says so. Called once on load, before anything strips the query string.
 */
export function rememberOpenedFromApp() {
  if (isServer) return;

  const params = new URLSearchParams(window.location.search);
  if (params.get('source') !== 'app') return;

  const scheme = params.get('appScheme');
  try {
    window.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ scheme: APP_SCHEME.test(scheme) ? scheme : null })
    );
  } catch {
    // Storage blocked - the visit just behaves like any other.
  }
}

/** @returns {boolean} Whether this visit came from the mobile app. */
export function isOpenedFromApp() {
  return !isServer && !!read();
}

/**
 * The app's link back to a game's screen in it, or null when this visit
 * didn't come from the app (or came without a valid scheme).
 *
 * @param {number|string} gameId
 * @returns {string|null}
 */
export function appGameUrl(gameId) {
  const scheme = !isServer && read()?.scheme;
  if (!scheme || !gameId) return null;
  return `${scheme}://screen/game_view?gameId=${encodeURIComponent(gameId)}`;
}
